import { httpPost } from "./request/requestApi";
const controllerEndpoint = "job";
export class JobApi {
    static triggerRecalculation(data) {
        return httpPost(`${controllerEndpoint}/ingestion/triggerRecalculation`, {
            body: data,
        });
    }
}
